import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, ElementRef } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ComponentBase } from '../../../classes/base/component-base';
import { UserService } from '../../../services/user.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/primeng';
import { FileType, OptionBrowseImage } from '../../../../dapfood/common/constant';
export class FileViewerComponent extends ComponentBase {
    constructor(ref, config, _UserService) {
        super();
        this.ref = ref;
        this.config = config;
        this._UserService = _UserService;
        this.scale = 100;
        this.top = 0;
        this.left = 0;
        this.dragging = false;
        this.rotation = 0;
        this.lastMouseX = 0;
        this.lastMouseY = 0;
        this.offsetX = 0;
        this.offsetY = 0;
        this.isPopupVisible = false;
        this.popupPosition = { x: 0, y: 0 };
        this.selectedIndex = 0;
        this.idPharmacy = -1;
        this.isShowBtnBrowse = false;
        this.modelBrowseImg = {};
        this.optionBrowse = -1;
        this.isShowDestroyConfirm = false;
        this.fileType = FileType;
        this.listFile = [];
        this.isShowRejectReason = false;
        this.rejectReason = '';
        this.commands = [
            { label: "Gán cho giấy tờ DKDN", action: 1 },
            { label: "Gán cho giấy chứng nhận DDKKDD", action: 2 },
            { label: "Gán cho GDP/GPP/GSP", action: 3 }
        ];
        this.emitDataImage = new EventEmitter();
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //window.addEventListener('wheel', this.onWheel.bind(this), { passive: false });
            yield this.showPopup(this.config.data.file, this.config.data.listFile || [], this.config.data.optionBrowse, this.config.data.obj);
        });
    }
    // ngOnDestroy(): void {
    //     window.removeEventListener('wheel', this.onWheel.bind(this));
    // }
    // Sử dụng với file list idFile
    showPopup(item, data = [], optionBrowse = -1, obj = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.listFile = [];
            if (data && data.length > 0) {
                data.forEach(item => {
                    // Mặc định là kiểu ảnh nếu không có kiểu
                    if (item.type == null || item.type == undefined)
                        item.type = FileType.Image;
                    // Chỉ view file image và video
                    if (item.type == FileType.Image || item.type == FileType.Video) {
                        item.link = this.getImageOriginal(item.id); // mặc định là theo kiểu ảnh
                        if (item.type == FileType.Video) {
                            item.type = FileType.Video;
                            item.link = `${environment.apiDomain.fileEndpoint}${this.file.path}`;
                        }
                        this.listFile.push(item);
                    }
                });
                // Nếu không truyền vào ảnh hiển thị mặc định thì lấy ảnh đầu tiên trong listFile
                if (item == null) {
                    this.file = this.listFile[0];
                }
            }
            if (item) {
                this.file = item;
                this.file.link = this.getImageOriginal(this.file.id); // mặc định là theo kiểu ảnh
                this.file.type = this.file.type ? this.file.type : FileType.Image; // Mặc định là kiểu ảnh
            }
            this.modelBrowseImg = obj;
            this.optionBrowse = (obj && obj.isAccepted) ? -1 : optionBrowse;
            if (this.optionBrowse == OptionBrowseImage.BrowseDisplay) {
                this.isShowDestroyConfirm = true;
            }
            this.idPharmacy = this.config.data.idPharmacy;
        });
    }
    // // Sử dụng với List Object File
    // showPopupObject(file: any, data: any[] = []) {
    //     if (data.length > 0) {
    //         this.listFile = data.filter(x => x.type == 1);  // Chỉ view file image và video
    //     }
    //     this.file = file;
    //     if (this.file.type == 3)
    //         this.file.url = `${environment.apiDomain.fileEndpoint}${this.file.path}`;
    //     else
    //         this.file.url = this.getImageOriginal(this.file.id);
    //     this.idPharmacy = file.idPharmacy;
    // }
    // Duyệt ảnh trưng bày, viếng thăm
    onAccepted(item, e) {
        const obj = {
            id: item.id,
            isAccepted: e.checked
        };
        if (this.ref) {
            this.ref.close(obj);
        }
    }
    onAcceptedDisplay(item, checked) {
        const obj = {
            id: item.id,
            isAccepted: true
        };
        if (this.ref) {
            this.ref.close(obj);
        }
    }
    onDestroyeddDisplay(item, checked) {
        const obj = {
            id: item.id,
            isAccepted: false,
            note: item.note
        };
        if (this.ref) {
            this.ref.close(obj);
        }
    }
    DestroyConfirmDisplay(check = false) {
        // this.showFileDialog = false;
        this.isShowRejectReason = true;
        this.rejectReason = '';
    }
    submitRejectReason() {
        if (this.rejectReason.trim()) {
            this.isShowRejectReason = false;
            const obj = Object.assign({}, this.modelBrowseImg, { note: this.rejectReason });
            const checked = { checked: false };
            this.onDestroyeddDisplay(obj, checked);
        }
        else {
            alert('Vui lòng nhập lý do không duyệt!');
        }
    }
    confirmImage() {
        if (this.optionBrowse == OptionBrowseImage.BrowseCheckIn) {
            this.onAccepted(this.modelBrowseImg, { checked: true });
        }
        if (this.optionBrowse == OptionBrowseImage.BrowseDisplay) {
            this.onAcceptedDisplay(this.modelBrowseImg, { checked: true });
        }
        // check optionBrowse để gọi các api cập nhật duyệt ảnh khác nếu có
    }
    // end duyệt
    getCurrent(item, index) {
        const currentIndex = this.listFile.indexOf(item);
        this.selectedIndex = currentIndex;
        this.file = this.listFile[currentIndex];
        // this.file.url = item.path ? this.getImageOriginal(this.file.id) : this.file.url;
        this.scale = 100;
        this.rotation = 0;
    }
    onNext() {
        this.scale = 100;
        this.rotation = 0;
        if (this.file == null || this.listFile == null || this.listFile.length <= 0)
            return;
        const currentIndex = this.listFile.indexOf(this.file);
        const nextIndex = (currentIndex + 1) % this.listFile.length;
        this.file = this.listFile[nextIndex];
        // this.file.url = this.file.path ? this.getImageOriginal(this.file.id) : this.file.url;
        this.selectedIndex = nextIndex;
    }
    onPrev() {
        this.scale = 100;
        this.rotation = 0;
        if (this.file == null || this.listFile == null || this.listFile.length <= 0)
            return;
        const currentIndex = this.listFile.indexOf(this.file);
        let prevIndex = 0;
        if (currentIndex <= 0)
            prevIndex = this.listFile.length - 1;
        else
            prevIndex = currentIndex - 1;
        // prevIndex = (currentIndex - 1) % this.listFile.length;
        this.file = this.listFile[prevIndex];
        // this.file.url = this.file.path ? this.getImageOriginal(this.file.id) : this.file.url;
        this.selectedIndex = prevIndex;
    }
    onKeydownHandler(event) {
        // event.preventDefault();
        if (event.key === 'ArrowLeft') {
            //if (event.keyCode == 37) {
            this.onPrev();
        }
        if (event.key === 'ArrowRight') {
            this.onNext();
        }
    }
    clickOutside(event) {
        this.isPopupVisible = false;
    }
    // urlFile(file) {
    //     if (file.path == null || file.path == undefined)
    //         return `/assets/images/no_image.jpg`; 
    //     return `https://docs.google.com/viewerng/viewer?url=https://wmapi.friends.vn/file.api//2023/9/23/mickey-tai-lieu-api_20230923115008708.docx`;
    // }
    // command menu
    openPopup(event, item) {
        if (this.idPharmacy > 0) {
            event.preventDefault();
        }
        let posX = event.clientX;
        let posY = event.clientY;
        const popupWidth = 150;
        const popupHeight = 100;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        if (posX + popupWidth > viewportWidth) {
            posX = viewportWidth - popupWidth;
        }
        if (posY + popupHeight > viewportHeight) {
            posY = viewportHeight - popupHeight;
        }
        this.popupPosition = { x: posX, y: posY };
        this.isPopupVisible = true;
    }
    command_option(label, actionType, file) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // const isConfirmed = window.confirm(`Bạn có chắc chắn muốn thực hiện lệnh: ${label}?`);
            // if (isConfirmed) {
            yield this._UserService.AssignCertificateType(this.idPharmacy, file.id, actionType)
                .then(response => {
                this.emitDataImage.emit(response.data);
                console.log('API thành công:', response);
            })
                .catch(error => {
                console.error('API lỗi:', error);
            });
            this.isPopupVisible = false;
            // }
            // console.log(this.idPharmacy);
            // console.log(file.id);
        });
    }
    // @HostListener('document:click')
    // closePopup() {
    //     this.isPopupVisible = false;
    // }
    closePopup() {
        this.ref.close(null);
    }
    // zoom ảnh
    onMouseDown(event, image) {
        if (event.button !== 0) {
            return;
        }
        this.dragging = true;
        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;
        image.style.cursor = 'grabbing';
    }
    onMouseMove(event) {
        if (!this.dragging)
            return;
        const deltaX = event.clientX - this.lastMouseX;
        const deltaY = event.clientY - this.lastMouseY;
        // this.left += deltaX;
        //this.top += deltaY;
        this.offsetX += deltaX;
        this.offsetY += deltaY;
        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;
    }
    onMouseUp() {
        this.dragging = false;
    }
    onWheel(event) {
        const isInside = this.container.nativeElement.contains(event.target);
        if (isInside) {
            event.preventDefault();
            let newScale = this.scale - event.deltaY * 0.2;
            newScale = Math.max(newScale, 100);
            newScale = Math.min(newScale, 500);
            this.scale = newScale;
        }
    }
    rotateImage(angle) {
        this.rotation = (this.rotation + angle) % 360; // Xoay ảnh, giữ giá trị trong khoảng 0-360
    }
    handleEscape(event) {
        if (this.ref) {
            this.ref.close();
        }
    }
}
